import { createApp } from 'vue';
import { createI18n } from 'vue-i18n'
import messagesNo from '../i18n/no.js';
import messagesEn from '../i18n/en.js';
import App from './ApplicationForm.vue';
import * as Sentry from "@sentry/browser";

class applicationForm {
    init() {
        const mountpoint = document.getElementById('applicationForm');
        if (mountpoint) {
            // Create and mount the Application form
            const i18n = createI18n({
                legacy: false,
                locale: 'no',
                fallbackLocale: 'no',
                messages: {
                    en: messagesEn,
                    no: messagesNo,
                }
            });

            const app = createApp(App)
            app.use(i18n);
	        app.mount(mountpoint);

            const sentryDsn = import.meta.env.VITE_SENTRY_DSN || null;

            Sentry.init({
                app,
                dsn: sentryDsn,
                environment: import.meta.env.MODE
            });
        }
    }
};
export default applicationForm;